module.exports = __webpack_public_path__ + "img/190624-culturally-competent-care-3-khn-ew-349p.60ea3f86.jpg";